import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import React from 'react';

export type ArticleType = {
  _id: string;
  subheading: string;
  title: string;
  video?: string | null;
  content?: string | null;
  published: boolean;
  published_at: string;
  image: string;
};

type AllDataType = {
  articles: ArticleType[]; // Assuming ArticleType is another type you've defined
  onDelete: (id: string) => void;
  onPublish: (status: string, id: string) => void;
};

const ArticleList: React.FC<AllDataType> = ({ articles, onDelete, onPublish }) => {
  const { t }: { t: (key: string, options?: any) => string } = useTranslation();
  
  console.log('ArticleList component rendered');
  console.log(articles)

  const publishedAt = (published_at: string): string => {
    const fecha = new Date(published_at);

    const day = fecha.getDate();
    const month = fecha.getMonth() + 1;
    const year = fecha.getFullYear();

    // Formatear la fecha como "dd/mm/yyyy"
    const formattedDate = `${day < 10 ? '0' : ''}${day}/${month < 10 ? '0' : ''}${month}/${year}`;
    return formattedDate;
  }

  return (
      <div className="container mx-auto">
        <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
              <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  <th scope="col" className="px-6 py-3">
                    {t('dashboard.title')}
                  </th>
                  <th>
                    {t('dashboard.published')}
                  </th>
                  <th>
                    {t('dashboard.published_at')}
                </th>
                <th>
                  {t('dashboard.image')}
                </th>
                <th scope="col" className="px-6 py-3 text-center">
                  {t('dashboard.actions')}
                </th>
                </tr>
              </thead>
            <tbody>
        {articles?.map(article => 
        (
          <tr
          className='even:bg-cian-100 odd:bg-gray-100'
            key={article._id}
          >
            <th scope="row" className="px-6 py-4 font-medium text-gray-900 dark:text-black whitespace-nowrap">
              {article.title.slice(0, 30)}
            </th>
            <th>
                {
                  article.published ?
                    <div className="flex items-center me-4">
                      <label className="ms-2 text-sm font-semibold text-green-900 dark:text-green-300">
                        {t('answer.yes')}
                      </label>
                    </div>
                    :
                    <div className="flex items-center me-4">
                      <label className="ms-2 text-sm font-semibold text-red-900 dark:text-red-300">
                        {t('answer.no')}
                      </label>
                  </div>
                }
            </th>
            <th>
                {
                  article.published_at && article.published ?
                  <div className="flex items-center me-4">
                    {publishedAt(article.published_at)}
                  </div>
                    :
                  <div className="flex items-center me-4">
                    No Data
                  </div>
                }
            </th>
            <th>
              {
                article.image ?
                  <Link className="-mx-3 block rounded-lg px-3 py-2.5 text-base font-semibold leading-7 text-red-900 hover:bg-red-50" data-te-nav-link-ref data-te-ripple-init data-te-ripple-color="light" to={`/upload-image/${article._id}`} state={{ article }}>
                    {t('dashboard.change_image')}
                  </Link>
                  :
                  <Link className="-mx-3 block rounded-lg px-3 py-2.5 text-base font-semibold leading-7 text-green-900 hover:bg-gray-50" data-te-nav-link-ref data-te-ripple-init data-te-ripple-color="light" to={`/upload-image/${article._id}`} state={{ article }}>
                    {t('dashboard.upload_image')}
                  </Link>
              }
            </th>
            <th className="px-6 py-4 text-center">
              <div className='space-y-1'>
              <Link
                  className='focus:outline-none text-white bg-yellow-400 hover:bg-yellow-500 focus:ring-4 focus:ring-yellow-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:focus:ring-yellow-900'
                  to={`/article/edit/${article._id}`} state={{ article }}>
                    {t('dashboard.edit')}
                </Link>
                <Link
                  className='focus:outline-none text-white bg-green-400 hover:bg-green-500 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:focus:ring-green-900'
                  to={`/article/${article._id}/preview`} state={{ article }}>
                    {t('dashboard.preview')}
                </Link>
                <button
                  className='focus:outline-none text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-900'
                  onClick={() => {onDelete(article._id)}}
                  >
                    {t('dashboard.delete')}
                </button>                      
                <div className="inline-flex rounded-md shadow-sm" role="group">
                  <button
                    disabled = { article.published ?  false : true}
                    type="button"
                    className="px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-s-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-blue-500 dark:focus:text-white"
                    onClick={()=>onPublish('false', article._id)}
                  >
                    {t('dashboard.hide')}
                  </button>
                  <button
                    disabled = { article.published ? true : false}
                    type="button"
                    className="px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-e-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-blue-500 dark:focus:text-white"
                    onClick={()=>onPublish('true', article._id)}
                  >
                    {t('dashboard.publish')}
                  </button>
                </div>
              </div>
            </th>
          </tr>
      ))}
      </tbody>
      </table>
      
      </div>
    )
  }

export default ArticleList;
